import React from 'react';
import { Handle, Position } from 'reactflow';

export default function EarningsNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  const mode = data.mode || 'days_until';

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #b45309',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#f59e0b' }}>
        📅 Earnings Proximity
      </div>

      <div style={{ display: 'flex', gap: 6 }}>
        <select
          value={mode}
          onChange={(e) => onChange('mode', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="days_until">Days Until Next Earnings</option>
          <option value="days_since">Days Since Last Earnings</option>
          <option value="within_window">Within N Days of Earnings</option>
        </select>
        {mode === 'within_window' && (
          <input
            type="number"
            min={1}
            value={data.window_days ?? 5}
            onChange={(e) => onChange('window_days', Math.max(1, parseInt(e.target.value, 10) || 5))}
            style={{ width: 56, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
          />
        )}
      </div>

      <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        Stocks only — ETFs, indices, FX, and crypto have no earnings dates and this node will resolve to nothing for them. Uses actual historical earnings dates (typically 20+ years for established tickers), not a model estimate.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#b45309' }} />
    </div>
  );
}
